"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.company.dataSource")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.company.dataRedirect", {
            url: "/data-redirect?source",
            params: {
                source: { value: null, dynamic: true }
            },
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-data-source" */ "./data-source.entry"
                ).then(() =>
                    Promise.all([
                        $ocLazyLoad.inject("nucont.accounting.company.dataSource"),
                        $ocLazyLoad.inject("nucont.accounting.company.department")
                    ])
                );
            },
            views: {
                "admin@nucont.accounting": {
                    component: "dataRedirectComponent",
                    bindings: { companyData: "CompanyData" }
                }
            }
        });
}
